import { buildAPIRequestUrl } from './build-url';
import { flattenJsonAPIData } from './data-formatter';
import { request } from '../request';
/**
 * Constructs the correct URL for the request, and makes the request.
 *
 * @param apiPath - The API URL to use for the request.
 * @param requestOptions - Options for the request such as headers, request method etc.
 * @param apiOptions - The API options to add onto the request URL.
 * @returns A Promise that will resolve with the data from the response.
 */
export function baseRequest(apiPath, requestOptions, apiOptions) {
    const resultUrl = buildAPIRequestUrl(apiPath, apiOptions);
    return request(resultUrl, requestOptions, flattenJsonAPIData);
}
//# sourceMappingURL=base-request.js.map